import React from 'react';

export default function Beliefs() {
  return (
    <main className="page-section beliefs" aria-labelledby="beliefs-title">
      <div className="page-container">
        <div className="glass-card beliefs-card">
          <header className="beliefs-header">
            <h1 className="title" id="beliefs-title">My Christian Beliefs</h1>
            <p className="subtitle">A short page about my faith and what guides me.</p>
          </header>

          <div className="body-text beliefs-body">
            <p>
              I’m a Christian. My faith shapes who I am, how I treat people, and how I try to live day-to-day.
              This isn’t meant to argue with anyone—just to share what I believe.
            </p>

            <section className="beliefs-section" aria-labelledby="beliefs-core">
              <h2 className="card-title" id="beliefs-core">Core beliefs</h2>
              <ul className="beliefs-list">
                <li><strong>Jesus Christ</strong> is my Lord and Savior.</li>
                <li><strong>Grace</strong> is a gift—salvation isn’t something we earn by being “good enough.”</li>
                <li><strong>The Bible</strong> is foundational for my beliefs and values.</li>
                <li><strong>Prayer</strong> matters: it’s how I bring worries, gratitude, and decisions to God.</li>
                <li><strong>Love + humility</strong>: I want to treat others with respect, patience, and compassion.</li>
                <li><strong>Jesus</strong> died on the cross so anyone who truly believes in Him can have eternal life.</li>
              </ul>

              <div className="beliefs-note">
                <p>
                  If you have a problem with my faith, that’s OK. Just please don’t try to intentionally hurt or disrespect me because of it.
                </p>
                <p>
                  If you have any questions, doubts, or are interested in learning more about my faith, please feel free to reach out.
                  I’d be more than happy to have a respectful and open conversation about it.
                </p>
              </div>
            </section>

            <section className="beliefs-section" aria-labelledby="beliefs-life">
              <h2 className="card-title" id="beliefs-life">How it affects my life</h2>
              <p>
                I try to be the same person online and offline: honest, reliable, and kind.
                When I mess up (because I do), I try to own it, apologize, and do better.
              </p>
            </section>

            <section className="beliefs-section" aria-labelledby="beliefs-verses">
              <h2 className="card-title" id="beliefs-verses">Verses I come back to</h2>
              <p className="beliefs-muted">
                I’m keeping this to references (not long quotes). A few that encourage me are:
                <strong> John 3:16</strong>, <strong>Micah 6:8</strong>, and <strong>Matthew 22:37–39</strong>.
              </p>
            </section>

            <section className="beliefs-section" aria-labelledby="beliefs-playlist">
              <h2 className="card-title" id="beliefs-playlist">A playlist I made</h2>
              <p>
                I spent countless hours putting this playlist together. If you’ve got a moment, I’d genuinely love it if you listened to it.
              </p>
              <div className="beliefs-embed">
                <iframe
                  data-testid="embed-iframe"
                  className="beliefs-embed-iframe"
                  src="https://open.spotify.com/embed/playlist/5y6VAJFe0tzE2zZG1M8whB?utm_source=generator"
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                  title="Spotify playlist"
                />
              </div>
            </section>

            <section className="beliefs-section" aria-labelledby="beliefs-respect">
              <h2 className="card-title" id="beliefs-respect">Respect</h2>
              <p>
                If you believe differently, you’re still welcome here. I’m always happy to talk respectfully,
                and I’ll do my best to listen.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}
